/**
 * @file
 * Add scripts for guide pages.
 */

const $sidebarMenu = $('.node--type-guide .sidebar nav .menu', context);

$sidebarMenu.once('guide-page').each(function() {
  const $this = $(this);
  const $sidebar = $('.node--type-guide .sidebar');

  // Initialize accordion menu.
  $this.addClass('vertical accordion-menu').attr('data-accordion-menu', '');
  $this.find('ul').addClass('menu vertical nested');
  $this.foundation();

  // Add button to open the menu on small and medium screen.
  const tocMarkup = `<div class="guide-toc hide-for-large"><h4><a href="#">${Drupal.t(
    'Table of Contents'
  )}</a></h4></div>`;

  $sidebar.find('.block-title').after(tocMarkup);

  $sidebar.find('.is-accordion-submenu-parent').each(function() {
    const $submenu = $(this).find('.submenu');
    $(this)
      .find('a')
      .first()
      .clone()
      .prependTo($submenu[0])
      .wrap(
        '<li class="is-submenu-item is-accordion-submenu-item" role="menuitem"></li>'
      );
  });

  // Show / hide popup menu.
  $('.guide-toc').click(function(event) {
    event.preventDefault();
    $sidebar.toggleClass('is-active');
    $('body').toggleClass('is-fixed');
  });
});
